export const config = {
  key: 'ebf-toast',
};
